/**
 * Calculate the size of the QR code based on the length of the URL.
 * @param {string} url - URL to be calculated
 * @returns {number} - The size of the QR code
 */
function calculateSizeBasedOnUrlLength(url) {
  let size = 128;
  if (!url) return size;
  const extraSizePer100Chars = 25;
  if (url.length > 200) {
    const extraChars = url.length - 200;
    const extraSize = Math.ceil(extraChars / 100) * extraSizePer100Chars;
    size += extraSize;
  }
  return size;
}
export default calculateSizeBasedOnUrlLength;
